import ArrowDownwardRoundedIcon from '@mui/icons-material/ArrowDownwardRounded'
import ArrowUpwardRoundedIcon from '@mui/icons-material/ArrowUpwardRounded'
import { Typography } from '@mui/material'

export type OutcomeTileDirection = 'down' | 'up' | 'none'

interface Props {
  color: string
  direction: OutcomeTileDirection
}

export const OutcomeTileDirectionIcon = ({ color, direction }: Props) => {
  if (direction === 'down') {
    return <ArrowDownwardRoundedIcon sx={{ color }} />
  }

  if (direction === 'up') {
    return <ArrowUpwardRoundedIcon sx={{ color }} />
  }

  return (
    <Typography variant='h6' fontWeight={700} sx={{ color, lineHeight: 1 }}>
      =
    </Typography>
  )
}
